export default "__VITE_ASSET__r3g92GFX__"